<template>
    <v-container>

        <template>
            <v-alert class="text-center" :value="!this.$store.state.OBJ_APPLICATION_INIT_LOADED" type="warning" icon="information" dismissible>{{this.$store.state.STRING_DATA_LOADING}}</v-alert>
            <br />
        </template>

        <template>
            <v-layout wrap>
                <v-flex xs12>
                    <v-toolbar>

                        <v-select :items="this.$store.state.OBJ_YEARS"
                                  label="Select Year"
                                  v-model="SELECTED_YEAR"
                                  v-on:change="SET_STATE"
                                  small-chips></v-select>

                        <v-divider class="mr-2" vertical></v-divider>

                        <v-select :items="FILTERED_STATES"
                                  item-text="State"
                                  item-value="State"
                                  label="Select a State"
                                  v-model="SELECTED_STATE"
                                  v-on:change="SET_STATE"
                                  small-chips></v-select>

                        <v-divider class="mr-2" vertical></v-divider>

                        <v-select :items="FILTERED_ELECTORATES"
                                  item-text="Electorate"
                                  item-value="Electorate"
                                  label="Select an Electorate"
                                  v-model="SELECTED_ELECTORATE"
                                  v-on:change="SET_ELECTORATE"
                                  small-chips></v-select>

                    </v-toolbar>
                </v-flex>
            </v-layout>


            [SELECTED_YEAR = {{this.SELECTED_YEAR}}]
            <br />
            [SELECTED_STATE = {{this.SELECTED_STATE}}]
            <br />
            [SELECTED_ELECTORATE = {{this.SELECTED_ELECTORATE}}]
            <br />

            [SELECTED_MAPFILE = {{this.SELECTED_MAPFILE}}]
            <br />

            <div id="detail">
                <hr />
                <label for="party">Date Established: {{this.ELECTORATE.Established | stringDateFormat }}]</label>
                <br>
                <label for="party">Name Origin: {{this.ELECTORATE.Origin}}</label>

                <br />

                <v-data-table :items="this.REPRESENTITIVES">
                    <template v-slot:items="props">
                        <router-link class="tr" :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.PHID }}">
                            <td class="text-xs-left"><Portrait v-bind:PHID="props.item.PHID" :fixedWidth="80"></Portrait></td>
                            <td class="text-xs-left">{{ props.item.DisplayName }} ({{ props.item.PartyAbbrev }})</td>
                            <!-- <td class="text-xs-left">{{ props.item.ServiceHistory_Start}}</td>  -->
                        </router-link>
                    </template>
                </v-data-table>

            </div>

            <div id="app">
                <mapbox access-token="pk.eyJ1IjoiYnJlbjIwMDAiLCJhIjoiY2p6eHpvNjlwMDI3ZDNtcXhqeXQ1NDduMCJ9.1zM42cfVQGBkr4VzMsg4Vg"
                        :map-options="{
              style: 'mapbox://styles/mapbox/light-v9',
              center: [133,-29],
              zoom: 3,
            }"
                        @map-load="loaded"
                        @map-zoomend="zoomend"
                        @map-click:points="clicked"
                        @geolocate-error="geolocateError"
                        @geolocate-geolocate="geolocate">
                </mapbox>
            </div>
        </template>
    </v-container>
</template>


<script>
    window.scrollTo(0, 0);
    //
    import Mapbox from 'mapbox-gl-vue'
    import axios from 'axios';
    import Portrait from '@/components/Portrait.vue'
    //
    export default {

        SELECTED_YEAR: "",
        SELECTED_STATE: "",
        SELECTED_ELECTORATE: "",
        SELECTED_MAPFILE: "",
        ELECTORATE: [],
        REPRESENTITIVES: [],

        components: {
            Mapbox,
            Portrait
        },

        data() {
            return {

                SELECTED_YEAR: "",
                SELECTED_STATE: "",
                SELECTED_ELECTORATE: "",
                SELECTED_MAPFILE: "",
                ELECTORATE: [],
                REPRESENTITIVES: [],

                DISTRIBUTIONROOT: 'https://handbook-api.azurewebsites.net/assets/geojson/NSW_2016-Current.geojson',
            }
        },

        methods: {

            SET_STATE() {
                this.SELECTED_MAPFILE = this.$store.state.OBJ_DISTRIBUTIONS.find(OBJ => OBJ.State == this.SELECTED_STATE
                    && OBJ.DateFrom <= this.SELECTED_YEAR
                    && OBJ.DateTo >= this.SELECTED_YEAR).KML_File
            },

            SET_ELECTORATE() {
                this.ELECTORATE = this.$store.state.OBJ_ELECTORATES.find(OBJ => OBJ.Electorate == this.SELECTED_ELECTORATE)
                let initialResults = this.$store.getters.GET_PARLIAMENTARIANS.filter(Obj => Obj.RepresentedElectorates.some(v => v.toString() === this.SELECTED_ELECTORATE))

                this.REPRESENTITIVES = this._.sortBy(initialResults, 'ServiceHistory_Start').reverse();
                initialResults = null
                // .Origin
                // .Established
            },

            FIRST2CHARS(string) {
                if (string && string != null) {
                    return string[0] + string[1];
                } else {
                    return string;
                }
            },


            loaded(map) {

                //  AT = 'pk.eyJ1IjoiYnJlbjIwMDAiLCJhIjoiY2p6eHpvNjlwMDI3ZDNtcXhqeXQ1NDduMCJ9.1zM42cfVQGBkr4VzMsg4Vg',
                //  URL = 'http://devwadsworth.parldev.net/assets/geojson/NSW_2016-Current.geojson',
                //    this.$store.state.URL_DISTRIBUTIONS
                //
                //  map.addControl(new mapboxgl.NavigationControl());

                /*
                      map.addLayer({
                        id: 'distributions',
                        type: 'line',
                        source: {
                          type: 'geojson',
                          data: this.DISTRIBUTIONROOT,
                          // tolerance: 1,
                        },
                      })
                */

            },

            zoomend(map, e) {
                //      console.log('Map zoomed')
            },

            clicked(map, e) {
                const title = e.features[0].properties.title
                //      console.log(title)
            },

            geolocateError(control, positionError) {
                //      console.log(positionError)
            },

            geolocate(control, position) {
                //      console.log(`User position: ${position.coords.latitude}, ${position.coords.longitude}`),
            },
        },

        computed: {

            FILTERED_STATES() {
                return this.$store.state.OBJ_DISTRIBUTIONS.filter(OBJ => OBJ.DateFrom <= this.SELECTED_YEAR
                    && OBJ.DateTo >= this.SELECTED_YEAR)
            },

            FILTERED_ELECTORATES() {
                return this.$store.state.OBJ_DISTRIBUTIONS.filter(OBJ => OBJ.State === this.SELECTED_STATE
                    && OBJ.DateFrom <= this.SELECTED_YEAR
                    && OBJ.DateTo >= this.SELECTED_YEAR)
            },
        },
    }
</script>

<style>
    body {
        margin: 0;
        padding: 0;
        font-size: small;
    }

    #map {
        position: relative;
        margin-top: 0px;
        width: 100%;
        height: 495px;
    }

    #filters {
        position: absolute;
        padding: 10px;
        top: 30px;
        left: 20px;
        width: 300px;
        background-color: cadetblue;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }

    #detail {
        position: absolute;
        padding: 10px;
        top: 220px;
        left: 20px;
        width: 500px;
        color: darkgoldenrod;
        font-family: Verdana, Geneva, Tahoma, sans-serif;
    }
</style>
